import { Injectable } from '@angular/core';
import { NbToastrService } from '@nebular/theme';
import { Subject } from 'rxjs';
import { WebsocketService } from './webSocket.service';

/**
 * Serviço de Chat utilizando WebSocket.
 *
 * Gerencia comunicação em tempo real via socket singleton compartilhado.
 * O listener de mensagens é registrado uma única vez na inicialização do serviço.
 */
@Injectable({ providedIn: 'root' })
export class ChatService {

  messages: Subject<any>;
  private listenerInitialized = false;

  constructor(
    private wsService: WebsocketService,
    private toastr: NbToastrService,
  ) {
    this.messages = this.wsService.connect();
    this.initChatListener();
  }

  /**
   * Envia uma mensagem através do WebSocket.
   *
   * @param msg - Mensagem a ser enviada
   */
  sendMsg(msg: any): void {
    this.wsService.emitMessage(msg);
  }

  /**
   * Registra um único listener global para mensagens recebidas via WebSocket.
   * Exibe toast quando a mensagem é destinada ao usuário logado.
   */
  private initChatListener(): void {
    if (this.listenerInitialized) {
      return;
    }
    this.listenerInitialized = true;
    this.wsService.messageEvents$.subscribe(msg => {
      const uid = sessionStorage.getItem('uid');
      if (uid && msg?.text?.['to'] === atob(uid)) {
        this.toastr.show(msg.text['msg'], 'De:' + msg.text['from'], { preventDuplicates: true });
      }
    });
  }
}
